import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdiantamentoListarRoutingModule } from './adiantamento-listar-routing.module';
import { AdiantamentoListarComponent } from './adiantamento-listar.component';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessagesModule } from 'primeng/messages';
import { TableModule } from 'primeng/table';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';


@NgModule({
  declarations: [
    AdiantamentoListarComponent
  ],
  imports: [
    CommonModule,
    AdiantamentoListarRoutingModule,
    FormsModule,
    TableModule,
    InputTextModule,
    ButtonModule,
    DividerModule,
    ProgressSpinnerModule,
    DropdownModule,
    MessagesModule,
    ConfirmDialogModule,
    CalendarModule
  ],
  providers: [ConfirmationService]
})
export class AdiantamentoListarModule { }
